import React from "react";
import { Tooltip } from "@material-ui/core";

// A disabled element blocks pointer events entirely, so a MUI Tooltip placed
// directly on a disabled Button/IconButton/Switch never fires - not on
// hover, and not on touch. On a mouse that just means no hint; on a
// touchscreen till (iPad, Android tablet) it means tapping a locked action
// does *nothing visible at all*, with no way to learn why.
//
// The fix MUI documents for this: put the Tooltip on a wrapping <span>
// instead of the disabled child - the span still receives pointer/touch
// events even though the button inside it doesn't. enterTouchDelay=0 makes
// it show immediately on tap rather than needing a long-press (the default),
// and leaveTouchDelay keeps it up long enough to actually read on a tap-only
// device.
//
// enabledTitle is for icon-only buttons that already had their own
// hover label (e.g. "Daily Sales Report") - it's shown instead of the
// permission message once the action is actually usable, so wrapping in
// this component doesn't silently drop a hint that was helpful before.
// Text-labelled buttons ("Add Employee") don't need one - the button's own
// visible label already says what it does.
const PermissionTooltip = ({
  disabled,
  message = "You don't have permission for this action",
  enabledTitle,
  children,
}) => {
  if (!disabled) {
    if (!enabledTitle) return children;
    return (
      <Tooltip title={enabledTitle} arrow enterDelay={150} enterTouchDelay={0} leaveTouchDelay={3000}>
        <span>{children}</span>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={message} arrow enterDelay={150} enterTouchDelay={0} leaveTouchDelay={3000}>
      <span>{children}</span>
    </Tooltip>
  );
};

export default PermissionTooltip;
